var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('vue-qr',{staticStyle:{},attrs:{"logoSrc":_vm.logo,"text":_vm.url,"size":200}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }